@use '@/shared/styles/settings' as settings;

.page {
  @include settings.body;
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  width: 100%;
  max-width: 1280px;
  min-width: 0;
  margin: 0 auto;
  color: var(--primary_text);

  :where(button, input, select, textarea) {
    font-family: var(--font-ui);
  }

  :where(button, input, select, textarea, summary, a):focus-visible {
    outline: 2px solid var(--interactive_focus);
    outline-offset: 2px;
  }
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-6);
  padding-bottom: var(--space-6);
  border-bottom: 1px solid var(--app-border);
}

.heading {
  min-width: 0;

  h1 {
    margin: 0;
    font-family: var(--font-ui);
    font-size: var(--text-page);
    font-weight: 600;
    line-height: 34px;
    letter-spacing: -0.025em;
    overflow-wrap: anywhere;
  }
}

.description {
  @include settings.body;
  max-width: 760px;
  margin-top: var(--space-2);
  color: var(--secondary_text);
  overflow-wrap: anywhere;
}

.actions {
  @include settings.toolbar;
  flex-shrink: 0;
  justify-content: flex-end;
  gap: var(--space-2);
  padding-top: var(--space-1);
}

.meta {
  @include settings.caption;
  margin-top: var(--space-3);
  color: var(--secondary_text);
}

.panel {
  @include settings.panel;
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.panelHeading {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);

  h2 {
    @include settings.heading;
  }

  p {
    @include settings.body;
    margin: var(--space-1) 0 0;
    color: var(--secondary_text);
  }
}

.icon {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  color: var(--secondary_text);

  svg {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 800px) {
  .header {
    flex-direction: column;
    gap: var(--space-4);
  }
  .actions {
    justify-content: flex-start;
    padding: 0;
  }
}
